module.exports = __webpack_public_path__ + "img/btn-plus.51be0d7f.svg";